import { Button } from '@/components/ui/button';

export interface FormActionsProps {
  submitLabel?: string;
  cancelLabel?: string;
  onCancel?: () => void;
  isSubmitting?: boolean;
  disabled?: boolean;
}

export function FormActions({
  submitLabel = 'Guardar',
  cancelLabel = 'Cancelar',
  onCancel,
  isSubmitting,
  disabled,
}: FormActionsProps): JSX.Element {
  return (
    <div className="flex justify-end gap-2 pt-2">
      {onCancel && (
        <Button type="button" variant="ghost" onClick={onCancel} disabled={isSubmitting}>
          {cancelLabel}
        </Button>
      )}
      <Button type="submit" disabled={isSubmitting || disabled}>
        {isSubmitting ? 'Guardando...' : submitLabel}
      </Button>
    </div>
  );
}
